import store from './../../store';

let DAODiamondStock = function () {
	this.getList = function (country, carat, color, finish, polish, purity, form, symmetry, fluorescence, price, certificateNo, certificate, stoneIds, stoneType, navSite, navLimit) {
		return new Promise((resolve) => {
			let url	= store.getters["config/getDiamondStockUrl"] + "/Designer/diamondsGetData.php";

			if (typeof carat !== 'object') {
				carat[0]= '0.3';
				carat[1]= '';
			} else {
				if (carat[0] === '' || carat[0] === undefined) {
					carat[0]= '0.3';
				}

				if (carat[1] === '' || carat[1] === undefined) {
					carat[1]= '';
				}
			}


			if (typeof color !== 'object') {
				color[0] = "6_id";
				color[1] = '';
			} else {
				if (color[0] === '' || color[0] === undefined) {
					color[0] = '6_id';
				}

				if (color[1] === '' || color[1] === undefined) {
					color[1]= '';
				}
			}

			if (typeof polish !== 'object') {
				polish[0] = "1_id";
				polish[1] = '';
			} else {
				if (polish[0] === '' || polish[0] === undefined) {
					polish[0] = '1_id';
				}

				if (polish[1] === '' || polish[1] === undefined) {
					polish[1]= '';
				}
			}

			if (typeof purity !== 'object') {
				purity[0] = "1_id";
				purity[1] = '';
			} else {
				if (purity[0] === '' || purity[0] === undefined) {
					purity[0] = '1_id';
				}

				if (purity[1] === '' || purity[1] === undefined) {
					purity[1]= '';
				}
			}

			if (typeof form !== 'string' || form === '') {
				form = 'A';
			}

			if (form === 'A') {
				if (typeof finish !== 'object') {
					finish[0] = "1_id";
					finish[1] = '';
				} else {
					if (finish[0] === '' || finish[0] === undefined) {
						finish[0] = '1_id';
					}

					if (finish[1] === '' || finish[1] === undefined) {
						finish[1]= '';
					}
				}
			} else {
				finish[0] = "5_id";
				finish[1] = '';
			}


			if (typeof symmetry !== 'object') {
				symmetry[0] = "5_id";
				symmetry[1] = '';
			} else {
				if (symmetry[0] === '' || symmetry[0] === undefined) {
					symmetry[0] = '5_id';
				}

				if (symmetry[1] === '' || symmetry[1] === undefined) {
					symmetry[1]= '';
				}
			}

			if (typeof fluorescence !== 'object') {
				fluorescence[0] = "6_id";
				fluorescence[1] = '';
			} else {
				if (fluorescence[0] === '' || fluorescence[0] === undefined) {
					fluorescence[0] = '6_id';
				}

				if (fluorescence[1] === '' || fluorescence[1] === undefined) {
					fluorescence[1]= '';
				}
			}

			if (typeof price !== 'string' || price === '') {
				price = '100';
			}

			if (typeof certificate !== 'string'  || certificate === '') {
				certificate = '1-2-3';
			}

			if (typeof certificateNo !== 'number' || certificateNo === 0) {
				certificateNo = '';
			}

			if (typeof stoneIds === 'object') {
				stoneIds	= JSON.stringify(stoneIds);
			} else {
				stoneIds	= false;
			}

			if (typeof navSite !== 'number' || navSite === '') {
				navSite = 1;
			}
			navSite--;

			if (typeof navLimit !== 'number' || navLimit === '') {
				navLimit = 10;
			}

			if (!parseInt(stoneType) > 0) {
				stoneType = 1;
			}

			let data = new FormData();
			data.append('search', '{' +
				'"price_select":{"from":"' + price + '","till":""},' +
				'"carat_select":{"from":"' + carat[0] + '","till":"' + carat[1] + '"},' +
				'"color_select":{"from":"' + color[0] + '","till":"' + color[1] + '"},' +
				'"finish_select":{"from":"' + finish[0] + '","till":"' + finish[1] + '"},' +
				'"polish_select":{"from":"' + polish[0] + '","till":"' + polish[1] + '"},' +
				'"symmetry_select":{"from":"' + symmetry[0]  + '","till":"' + symmetry[1] + '"},' +
				'"purity_select":{"from":"' + purity[0] + '","till":"' + purity[1] + '"},' +
				'"fluorescence_select":{"from":"' + fluorescence[0]  + '","till":"' + fluorescence[1] + '"},' +
				'"stoneform_select":{"from":"' + form + '","till":"' + form + '"},' +
				'"certificate":{"nr":"' + certificateNo + '"},' +
				'"certificate_select":"' + certificate + '",' +
				'"stoneType":"' + stoneType + '",' +
				'"stoneIds": ' + stoneIds +
				'}');

			data.append('navLimit', navLimit);
			data.append('navSite', navSite);
			data.append('code', country);
			data.append('ac', 'get_list');
			data.append('standaloneDB', true);

			fetch(url, {
				method: 'post',
				body: data
			}).then(response => {
				response.json().then(json => {
					if (typeof json.list === 'object') {
						json.list = this.formatList(json.list);
					}
					resolve(json);
				});
			});
		});
	}


	/**
	 * Fix Certificate (Dettinger)
	 */
	this.fixCertificate = (diamond) => {
		if (typeof diamond.supplier === 'string') {
			if (diamond.supplier === '10010') {
				let certNr					= diamond.certificateNr.trim();
				let lastCharOfCertificate	= certNr.substr(certNr.length - 1, certNr.length);

				if (lastCharOfCertificate === 'D' || lastCharOfCertificate === 'd') {
					diamond.certificateNr	= certNr.substr(0, certNr.length - 1);
				}
			}

			// Last 2 chars of supplierId
			let supplierIdLength	= diamond.supplier.length;
			diamond.supplierKey		= diamond.supplier.substr(supplierIdLength - 2, supplierIdLength);
		}
		return diamond;
	}

	this.formatList = (diamondList) => {
		for (let id in diamondList) {
			diamondList[id] = this.fixCertificate(diamondList[id]);
		}
		return diamondList;
	}
}

export default new DAODiamondStock();
